import { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import transformToPascalCase from 'components/Settings/Utilities/TransformToPascalCase';
import { store } from 'components/Store';
import Create from './ui/Create';
import CreatePolicyMaterialContent, { materialPromptsPhrases } from './ui/CreatePolicyMaterialContent';
import useAddMetaTags from 'components/Dashboard/utilities/addMetaTags';
import useGetRemainingCredits from 'components/Dashboard/hooks/useGetRemainingCredits';

const WritingCreate = (props) => {
  const { individualPage } = props;
  const globalState = useContext(store);
  const { dispatch } = globalState;

  const { generalApiCall } = useGeneralApiCall();
  const { addMetaTags } = useAddMetaTags();
  const { updateRemainingCredits } = useGetRemainingCredits();

  const params = useParams();
  const { title: contentType } = params;

  const location = useLocation();
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [phrases, setPhrases] = useState(['', '', '']);

  const changeContentType = () => {
    switch (contentType) {
      case 'debate-contribution':
        return 'ParliamentarianDebateContribution';
      case 'question':
        return 'ParliamentarianQuestion';
      case 'edm':
        return 'ParliamentarianEDM';
      case 'response-to-a-constituent':
        return 'ParliamentarianConsituentResponse';
      default:
        return transformToPascalCase(contentType.replace('-', ' '));
    }
  };

  const createFunction = async ({ prompt, body }) => {
    try {
      const pathname = `/api/writing-assistant-generated-content/create`;
      const method = 'post';
      const requestProperties = {
        title,
        contentType: changeContentType(),
        body,
        prompt,
        promptData: {
          title,
          phrases: JSON.stringify(phrases.filter((item) => item !== '')),
        },
      };
      const results = await generalApiCall({ pathname, method, requestProperties, needsAuthentication: true });
      await updateRemainingCredits();
      if (results) {
        return navigate({
          pathname: `/ai-assistant/content/${results?.id}`,
          state: { influencePage: location?.state?.influencePage },
        });
      }
    } catch (error) {}
  };

  const sentPromptFromWritingAssistant = ({ prompt }) => {
    dispatch({ type: 'MODIFY_SECTION', parameter: 'promptFromWritingAssistant', value: prompt });
    navigate(
      {
        pathname: `/brief-policymakers/${contentType === 'policy-ask' ? 'policy-asks' : contentType}/create/1`,
        search: `?returnUrl=${encodeURIComponent(`${location.pathname}${location.search}${location.hash}`)}`,
      },
      { state: { headline: title, client: location?.state?.client, websiteLink: location?.state?.websiteLink } }
    );
  };

  useEffect(() => {
    let title = `AI assistant - PolicyMogul`;
    addMetaTags({ title, hash: location.hash });
  }, []);

  const ContentComponent = materialPromptsPhrases[contentType] ? CreatePolicyMaterialContent : Create;

  return (
    <>
      <ContentComponent
        titleValues={{ title, setTitle }}
        phrasesValues={{ phrases, setPhrases }}
        createFunction={createFunction}
        individualPage={individualPage}
        sentPromptFromWritingAssistant={sentPromptFromWritingAssistant}
      />
    </>
  );
};

export default WritingCreate;
